var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1122_16793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67772 10.5208L0.84668 19.8935C0.847509 19.8952 0.847509 19.8977 0.848338 19.8993C1.11957 20.917 2.04854 21.666 3.15169 21.666C3.59295 21.666 4.00684 21.5466 4.36185 21.3376L4.39005 21.321L14.33 15.5854L9.67772 10.5208Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6122 8.92539L18.6039 8.91958L14.3123 6.43209L9.47754 10.7344L14.3298 15.585L18.5981 13.1224C19.3462 12.7176 19.8547 11.9288 19.8547 11.0197C19.8547 10.1156 19.3537 9.33099 18.6122 8.92539Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84691 2.10456C0.793826 2.30031 0.765625 2.50601 0.765625 2.71835V19.2806C0.765625 19.4929 0.793826 19.6986 0.84774 19.8936L9.98153 10.7606L0.84691 2.10456Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74325 11L14.3135 6.43062L4.38507 0.674306C4.02426 0.457823 3.60291 0.333407 3.15252 0.333407C2.04937 0.333407 1.11874 1.08405 0.847509 2.1026C0.847509 2.10343 0.84668 2.10426 0.84668 2.10509L9.74325 11Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_16793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0888,
    height: 21.3333,
    fill: "white",
    transform: "translate(0.765625 0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/google-play-logo.90d6d9e1d7d503260a61f8f3bcd2ef89.svg";
export { ForwardRef as ReactComponent };